import { render, staticRenderFns } from "./FirebaseMessage.vue?vue&type=template&id=f6a81c7e"
import script from "./FirebaseMessage.vue?vue&type=script&lang=ts"
export * from "./FirebaseMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports